// eslint-disable-next-line import/prefer-default-export
export const UploadMetadataSelector = ({
  metadataUpload: { uploadDataSummary }
}) => uploadDataSummary;
